var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 16.3563V7.53005C3.33337 5.15171 3.33337 3.96254 4.06561 3.22369C4.79784 2.48483 5.97635 2.48483 8.33337 2.48483H11.6667C14.0237 2.48483 15.2022 2.48483 15.9345 3.22369C16.6667 3.96254 16.6667 5.15171 16.6667 7.53005V16.3563C16.6667 17.6161 16.6667 18.2459 16.2817 18.4938C15.6526 18.8991 14.6801 18.0493 14.191 17.7409C13.7868 17.486 13.5848 17.3586 13.3605 17.3512C13.1181 17.3432 12.9125 17.4655 12.4758 17.7409L10.8834 18.7452C10.4538 19.016 10.239 19.1515 10 19.1515C9.76104 19.1515 9.54629 19.016 9.11671 18.7452L7.52432 17.7409C7.12017 17.486 6.91809 17.3586 6.69382 17.3512C6.45147 17.3432 6.24582 17.4655 5.8091 17.7409C5.32 18.0493 4.34743 18.8991 3.71833 18.4938C3.33337 18.2459 3.33337 17.6161 3.33337 16.3563Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 9.98483H6.66663",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 6.65152H6.66663",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.92f6edaa42c43e388066aa156a3a2490.svg";
export { ForwardRef as ReactComponent };